import { useRef, useCallback, useEffect } from 'react';
import { POLLING_INTERVAL, POLLING_TIMEOUT } from '../data/constants';

export const usePaymentPolling = () => {
  const timeoutIdRef = useRef(null);
  const isActiveRef = useRef(false);
  
  const stopPolling = useCallback(() => {
    console.log('🛑 Parando polling');
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    }
    isActiveRef.current = false;
  }, []);
  
  const startPolling = useCallback((orderId, checkFunction, onSuccess, onError, onTimeout) => {
    console.log('🚀 INICIANDO POLLING - Timestamp:', Date.now());

    // Modo de teste: aprova automaticamente após 5 segundos
    if (process.env.REACT_APP_TEST_MODE === 'true') {
      console.log('🧪 TEST MODE: aprovação automática em 5s');
      stopPolling();
      isActiveRef.current = true;
      timeoutIdRef.current = setTimeout(() => {
        if (isActiveRef.current) {
          stopPolling();
          onSuccess?.();
        }
      }, 5000);
      return;
    }

    // Para qualquer polling anterior
    stopPolling();
    isActiveRef.current = true;

    const pollFunction = async () => {
      if (!isActiveRef.current) {
        console.log('⚠️ Polling inativo, cancelando');
        return;
      }
      
      console.log('⚡ EXECUTANDO POLL para:', orderId);
      
      try {
        const status = await checkFunction(orderId);
        
        if (!isActiveRef.current) {
          console.log('⚠️ Polling parado durante execução');
          return;
        }
        
        if (status === 'confirmed') {
          stopPolling();
          onSuccess?.();
          return;
        } else if (status === 'cancelled' || status === 'expired' || status === 'chargeback') {
          stopPolling();
          onError?.('Pagamento rejeitado');
          return;
        }
        
        // Agenda próxima verificação se ainda ativo
        if (isActiveRef.current) {
          timeoutIdRef.current = setTimeout(pollFunction, POLLING_INTERVAL);
        }
        
      } catch (error) {
        console.error('Erro no polling:', error);
        if (isActiveRef.current) {
          timeoutIdRef.current = setTimeout(pollFunction, POLLING_INTERVAL);
        }
      }
    };
    
    // Inicia primeira verificação
    pollFunction();
    
    // Timeout de segurança global
    setTimeout(() => {
      if (isActiveRef.current) {
        stopPolling();
        onTimeout?.();
      }
    }, POLLING_TIMEOUT);
    
  }, [stopPolling]);
  
  // Cleanup automático quando componente desmonta
  useEffect(() => {
    return () => {
      stopPolling();
    };
  }, [stopPolling]);
  
  return { startPolling, stopPolling };
};